import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Callback({ onLoginSuccess }) {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const completeLogin = async () => {
      const code = new URLSearchParams(window.location.search).get('code');

      // If someone landed here without an OAuth redirect, send them to login.
      if (!code) {
        navigate('/login', { replace: true });
        return;
      }

      try {
        const resp = await fetch('/api/github/callback', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',                 // <-- important for session cookies
          body: JSON.stringify({ code }),
        });

        if (!resp.ok) {
          setError('Login failed. Please try again.');
          setTimeout(() => navigate('/login', { replace: true }), 1200);
          return;
        }

        // Mark session as logged in for the app
        if (typeof onLoginSuccess === 'function') onLoginSuccess();

        // Don’t persist /callback as a last route; set a safe landing page.
        try {
          localStorage.setItem('rt_last_route', '/survey'); // first stop after login
          // If you’re tracking flow stages, you can initialize/reset here as needed
          // localStorage.setItem('rt_flow_stage', 'survey');
        } catch {}

        // Go to the survey (or "/" if you prefer).
        navigate('/survey', { replace: true });
      } catch {
        setError('Network error. Please try again.');
        setTimeout(() => navigate('/login', { replace: true }), 1200);
      }
    };

    completeLogin();
  }, [navigate, onLoginSuccess]);

  return <div>{error ? `Error: ${error}` : 'Signing you in…'}</div>;
}

export default Callback;
